import { useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { useAuth } from "../context/AuthContext";

export default function AdminSettings({ navigate }) {
  const { user, changePass, logout } = useAuth();
  const [pwd,  setPwd]  = useState({new:"",confirm:""});
  const [msg,  setMsg]  = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.new.length < 6)        return setMsg({type:"err",text:"Password must be at least 6 characters."});
    if (pwd.new !== pwd.confirm)    return setMsg({type:"err",text:"Passwords do not match."});
    await changePass(user.email, pwd.new);
    setMsg({type:"ok",text:"Password updated successfully."});
    setPwd({new:"",confirm:""});
  };

  const iStyle = {width:"100%",padding:"11px 14px",border:"1.5px solid #dde3ed",borderRadius:9,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:"#0d1f3c",background:"#fafbfd",outline:"none",boxSizing:"border-box"};
  const lbl = t => <label style={{display:"block",fontSize:11,fontWeight:600,letterSpacing:"1.5px",textTransform:"uppercase",color:"#5a6a80",marginBottom:6}}>{t}</label>;

  const Card = ({icon,title,children}) => (
    <div style={{background:"#fff",borderRadius:14,border:"1px solid #e4e9f0",overflow:"hidden"}}>
      <div style={{padding:"18px 22px",borderBottom:"1px solid #eaeef5",display:"flex",alignItems:"center",gap:10,background:"linear-gradient(135deg,#fafbfd,#fff)"}}>
        <span style={{fontSize:18}}>{icon}</span>
        <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,fontWeight:600,color:"#0d1f3c"}}>{title}</h2>
      </div>
      <div style={{padding:22}}>{children}</div>
    </div>
  );

  return (
    <AdminLayout navigate={navigate} active="settings" title="Settings">
      <div className="rgrid-2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,marginBottom:20}}>

        <Card icon="🔐" title="Change Password">
          {msg && <div style={{background:msg.type==="ok"?"#dcfce7":"#fee2e2",border:`1px solid ${msg.type==="ok"?"#22c55e":"#ef4444"}`,color:msg.type==="ok"?"#166534":"#991b1b",padding:"12px 14px",borderRadius:10,fontSize:13,marginBottom:16}}>{msg.type==="ok"?"✅":"⚠"} {msg.text}</div>}
          <form onSubmit={submit}>
            <div style={{marginBottom:14}}>{lbl("New Password")}<input type="password" value={pwd.new} onChange={e=>setPwd(p=>({...p,new:e.target.value}))} placeholder="Min 6 characters" style={iStyle} required/></div>
            <div style={{marginBottom:18}}>{lbl("Confirm Password")}<input type="password" value={pwd.confirm} onChange={e=>setPwd(p=>({...p,confirm:e.target.value}))} placeholder="Repeat password" style={iStyle} required/></div>
            <button type="submit" style={{padding:"11px 22px",background:"linear-gradient(135deg,#4a7fb5,#d4736a)",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:600,cursor:"pointer"}}>💾 Update Password</button>
          </form>
        </Card>

        <Card icon="👤" title="Account Info">
          <table style={{width:"100%"}}>
            {[["Name",user?.name],["Email",user?.email],["Agency",user?.agency],["Role",user?.role]].map(([l,v])=>(
              <tr key={l} style={{borderBottom:"1px solid #f0f3f9"}}>
                <td style={{padding:"10px 0",fontSize:12,color:"#6b7a90",width:80}}>{l}</td>
                <td style={{padding:"10px 0",fontSize:13,fontWeight:600,color:l==="Email"?"#4a7fb5":"#1a2540"}}>{v}</td>
              </tr>
            ))}
          </table>
          <button onClick={logout} style={{marginTop:18,padding:"10px 20px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:9,fontSize:13,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>🚪 Sign Out</button>
        </Card>
      </div>

      <Card icon="🌐" title="Portal Information">
        <div className="rgrid-3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
          {[["Portal","AIHOVI B2B"],["Website","airhotelvisa.com"],["Services","Air · Hotel · Visa"],["Version","React 18"],["Framework","Create React App"],["Status","Active ✅"]].map(([l,v])=>(
            <div key={l} style={{background:"#f6f8fc",borderRadius:10,padding:"13px 15px"}}>
              <div style={{fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600,marginBottom:4}}>{l}</div>
              <div style={{fontSize:13,fontWeight:600,color:"#1a2540"}}>{v}</div>
            </div>
          ))}
        </div>
      </Card>
    </AdminLayout>
  );
}
